import { BannerComponentFields } from '@types';

import { BlockBase } from '../utils';

export const transformBannerData = ({
  params,
  href,
  actions,

  // these should be destructured from the props so they're not passed to the dom
  buttonText,
  internalLink,
  ...data
}: BannerComponentFields & BlockBase) => {
  const prefix = params?.venue ? `/${params.venuesPage}/${params.venue}` : '';

  return {
    ...data,
    href: href && !href?.includes('https://') ? `${prefix}${href}` : href,
    actions: {
      primary: {
        ...actions?.primary,
        href:
          !actions?.primary?.href?.includes('https://') && params?.venue
            ? `${prefix}${actions?.primary?.href}`
            : actions?.primary?.href,
      },
      secondary: {
        ...actions?.secondary,
        href:
          !actions?.secondary?.href?.includes('https://') && params?.venue
            ? `${prefix}${actions?.secondary?.href}`
            : actions?.secondary?.href,
      },
    },
  };
};
